import { Divider, Table } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { ProductGroup } from './LufthansaCapabilities';

interface ProductRow {
  key?: string;
  name?: string;
  pharma?: string;
  availability?: boolean | number | string;
  remarks?: boolean | number | string;
}

interface AirFranceProductTabProps {
  products?: ProductGroup[]; // ProductGroup must be an array for `.map()` usage
}

const AirFranceProductTab = ({ products }: AirFranceProductTabProps) => {
  const getColumns = (firstColumnTitle: string) => {
    return [
      {
        title: firstColumnTitle,
        dataIndex: 'pharma',
        key: 'pharma',
        width: '55%',
        minWidth: 300,
        render: (_: string, record: ProductRow) => record?.name ?? null,
      },
      {
        title: 'Availability',
        dataIndex: 'availability',
        key: 'availability',
        width: '15%',
        render: (_: boolean | number | string, record: ProductRow) =>
          record?.availability === true ? <CheckOutlined /> : '-',
      },
      {
        title: 'Remark',
        dataIndex: 'remarks',
        key: 'remarks',
        width: '15%',
        render: (_: string | boolean | number, record: ProductRow) =>
          record?.remarks ?? null,
      },
    ];
  };

  // safe fallback for map() – must be an array
  const safeProducts: ProductGroup[] = Array.isArray(products) ? products : [];

  return (
    <div>
      {[...safeProducts].reverse().map((product, index) => {
        return (
          <div key={index}>
            <Table<ProductRow>
              className='zl-custom-times-table'
              dataSource={(product.capabilities ?? []) as ProductRow[]}
              columns={getColumns(product.name ?? '')}
              pagination={false}
              rowHoverable={false}
              bordered
            />
            {index !== safeProducts.length - 1 && <Divider />}
          </div>
        );
      })}
    </div>
  );
};

export default AirFranceProductTab;
